import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import AllEvents from '@jumbo/Dashboards/Events';
import { useHistory } from 'react-router';
import { Box, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.eventsPage'} />, isActive: 'true' },
];

const Events = () => {
  const history = useHistory();
  return (
    <PageContainer heading={<IntlMessages id="pages.eventsPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Box display="flex" justifyContent={'space-between'} alignItems={'center'} marginBottom={'10px'}>
            <div style={{ marginBottom: 10 }}>
              <IntlMessages id="pages.eventsPage.description" />
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => history.push('/createEvent')}
              style={{ marginRight: 14 }}>
              ایجاد رخداد
            </Button>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllEvents />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Events;
